export type MatchResultType = "W" | "L" | "D";

export function determineMatchResult(
  match: {
    winner?: number | 1 | 2 | "draw";
    matchResult?: string;
    score?: number;
  },
  isTeam1: boolean
): MatchResultType {
  if (match.matchResult) {
    const parts = match.matchResult.split("-");
    if (parts.length === 2) {
      const team1Sets = parseInt(parts[0], 10);
      const team2Sets = parseInt(parts[1], 10);

      if (team1Sets === team2Sets) {
        return "D";
      }

      if (isTeam1) {
        return team1Sets > team2Sets ? "W" : "L";
      } else {
        return team2Sets > team1Sets ? "W" : "L";
      }
    }
  }

  if (match.winner !== undefined) {
    if (match.winner === "draw") {
      return "D";
    }
    const winnerNum =
      typeof match.winner === "number"
        ? match.winner
        : match.winner === 1
        ? 1
        : 2;
    if (isTeam1) {
      return winnerNum === 1 ? "W" : "L";
    } else {
      return winnerNum === 2 ? "W" : "L";
    }
  }

  if (match.score !== undefined) {
    if (isTeam1) {
      if (match.score > 0.5) return "W";
      if (match.score < 0.5) return "L";
      return "D";
    } else {
      const reversedScore = 1 - match.score;
      if (reversedScore > 0.5) return "W";
      if (reversedScore < 0.5) return "L";
      return "D";
    }
  }

  return "D";
}
